export default function isInternetExplorer() {
  // we only check for IE11, since the site won't support earlier versions anyway
  return navigator.userAgent.indexOf('Trident/') >= 0;
}
